"use strict";
/* eslint no-case-declarations: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reducerFn;

var _cache = require("./utils/cache");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Reducer contructor
 * @param  {Object}   initialState default initial state
 * @param  {Object}   actions      actions map
 * @param  {Function} reducer      custom reducer function
 * @return {Function}              reducer function
 */
function reducerFn(initialState) {
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reducer = arguments.length > 2 ? arguments[2] : undefined;
  var actionFetch = actions.actionFetch,
      actionSuccess = actions.actionSuccess,
      actionFail = actions.actionFail,
      actionReset = actions.actionReset,
      actionCache = actions.actionCache,
      actionAbort = actions.actionAbort;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var request = action.request || {};

    switch (action.type) {
      case actionFetch:
        return _objectSpread({}, state, {
          request: request,
          loading: true,
          error: null,
          syncing: !!action.syncing
        });

      case actionSuccess:
        return _objectSpread({}, state, {
          loading: false,
          sync: true,
          syncing: false,
          error: null,
          data: action.data
        });

      case actionFail:
        return _objectSpread({}, state, {
          loading: false,
          error: action.error,
          syncing: false
        });

      case actionReset:
        var mutation = action.mutation;
        return mutation === "sync" ? _objectSpread({}, state, {
          request: null,
          sync: false
        }) : _objectSpread({}, initialState);

      case actionAbort:
        return _objectSpread({}, state, {
          request: null,
          loading: false,
          syncing: false,
          error: action.error
        });

      case actionCache:
        var id = action.id,
            data = action.data;
        var cacheExpire = state.cache[id] ? state.cache[id].expire : null;
        var expire = (0, _cache.setExpire)(action.expire, cacheExpire);
        return _objectSpread({}, state, {
          cache: _objectSpread({}, state.cache, _defineProperty({}, id, {
            expire: expire,
            data: data
          }))
        });

      default:
        return reducer ? reducer(state, action) : state;
    }
  };
}

module.exports = exports.default;
//# sourceMappingURL=reducerFn.js.map